<template>
  <div class="main">
    <dd-header></dd-header>
    <div class="content_main">
      <h1>アップロード完了</h1>
      <section class="confirm_sec">
        <p>
          スケッチアップロードが完了いたしました。<br>
          プランニング担当者からご連絡いたしますので、お待ちください。
        </p>
      </section>
    </div>
    <div class="form_submit">
      <div class="action_area">
        <button type="button" @click="goTop">TOPへ戻る</button>
      </div>
    </div>
    <dd-footer></dd-footer>
  </div>
</template>
<script>
import * as App from '../utils/App'
import {SO_STORAGE_KEY} from '../constants/App'
import Header from '../components/Header'
import Footer from '../components/Footer'

export default {
  name: 'UploadConfirm',
  // props: {
  //   inputForm: Object
  // },
  components: {
    'dd-header': Header,
    'dd-footer': Footer
  },
  data () {
    return {
      inputForm: {}
    }
  },
  computed: {
  },
  methods: {
    getImage: function (image) {
      return App.getSketchResource(image)
    },
    goTop: function () {
      this.$router.push({
        name: 'Top'
      })
    }
  },
  mounted () {
  },
  created () {
    console.log('input form------------')
    // console.dir(this.inputForm)
    this.inputForm = App.getLocalStorage(SO_STORAGE_KEY.SKETCH_UPLOAD)
  }
}
</script>
<style src="../css/top.scss" lang="scss" scoped></style>
<style src="../css/main.scss" lang="scss" scoped></style>
<style src="../css/style.scss" lang="scss" scoped></style>
<style src="../css/upload.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/pages/UploadComplete.vue